/* hs-eslint ignored failing-rules */

import { ERROR_CODES } from '../../constants/ApiErrorConstants';
import ImportApi from '../api/Import';
import ActionTypes from './ActionTypes';
export function startImport(url, autoPublish, knowledgeBaseId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.START_OR_CANCEL_IMPORT_PENDING
    });
    return ImportApi.startImport({
      url,
      autoPublish,
      knowledgeBaseId
    }).then(() => dispatch({
      payload: {
        knowledgeBaseId
      },
      type: ActionTypes.START_IMPORT_SUCCESS
    }), error => {
      dispatch({
        error,
        type: ActionTypes.START_OR_CANCEL_IMPORT_ERROR
      });
      throw new Error(error);
    });
  };
}
export function cancelImport({
  knowledgeBaseId
}) {
  return dispatch => {
    dispatch({
      type: ActionTypes.START_OR_CANCEL_IMPORT_PENDING
    });
    return ImportApi.cancelImport(knowledgeBaseId).then(payload => dispatch({
      payload,
      type: ActionTypes.CANCEL_IMPORT_SUCCESS
    }), error => dispatch({
      error,
      type: ActionTypes.START_OR_CANCEL_IMPORT_ERROR
    }));
  };
}
export function resetImport() {
  return {
    type: ActionTypes.START_OR_CANCEL_RESET
  };
}

// This let us use quick-fetch in knowledge-content-ui
export function makeGetProgress(getProgressFromApi = ImportApi.getProgress) {
  return knowledgeBaseId => dispatch => {
    dispatch({
      type: ActionTypes.FETCH_IMPORT_PROGRESS_PENDING,
      payload: {
        knowledgeBaseId
      }
    });
    getProgressFromApi(knowledgeBaseId).then(payload => dispatch({
      payload: Object.assign({}, payload, {
        knowledgeBaseId
      }),
      type: ActionTypes.FETCH_IMPORT_PROGRESS_SUCCESS
    }), error => {
      if (error.status === ERROR_CODES.NOT_FOUND) {
        dispatch({
          payload: {
            knowledgeBaseId
          },
          type: ActionTypes.FETCH_IMPORT_PROGRESS_SUCCESS
        });
      } else {
        dispatch({
          error,
          type: ActionTypes.FETCH_IMPORT_PROGRESS_ERROR
        });
      }
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export const getProgress = makeGetProgress();